import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import Popup from "./Components/Popup";
import { setCallWidget, setPageCondition } from "./formSlice";
// import DisabledPortalPopup from './Components/MuiPopup';

function TestBoss() {
  const [alertField, setAlertField] = useState("annualIncome");
  const [ckeckTimer, setCkeckTimer] = useState(false);
  const activityTimeoutRef = useRef(null);
  const popupShownRef = useRef(false);
  const [focusedField, setFocusedField] = useState(false);
  const dispatch = useDispatch();
  const isWidgetOpen = localStorage.getItem("isWidgetOpen");

  //   useEffect(() => {
  //     if (isWidgetOpen == 1) {
  //       setCkeckTimer(false);
  //     }
  //   }, [isWidgetOpen]);
  useEffect(() => {
    if (isWidgetOpen === 1) {
      //   popupShownRef.current = false; // allow again
      //   resetActivityTimeout();
      setCkeckTimer(false);
    }
  }, [isWidgetOpen]);

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .max(15, "Must be 15 characters or less")
      .required("Required"),
    lastName: Yup.string()
      .max(20, "Must be 20 characters or less")
      .required("Required"),
    mobileNumber: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits")
      .required("Required"),
    email: Yup.string().email("Invalid email address").required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      annualIncome: "",
      setDate: "",
      firstName: "",
      lastName: "",
      gender: "",
      isSmoke: "",
      mobileNumber: "",
      email: "",
      isEmployee: "",
      isState: "",
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: false,

    onSubmit: (values) => {
      //   console.log(values);
    },

    handleBlur: (e) => {
      (console, log(e, "value"));
    },
  });

  //   const resetActivityTimeout = () => {
  //     setTimeout(() => {
  //       setCkeckTimer(false);
  //     }, 500);
  //     if (activityTimeoutRef.current) {
  //       clearTimeout(activityTimeoutRef.current);
  //     }
  //     activityTimeoutRef.current = setTimeout(() => {
  //       setCkeckTimer(true);
  //     }, 15000);
  //   };

  const resetActivityTimeout = () => {
    // ✅ If popup already shown once, stop everything
    if (popupShownRef.current) return;

    // Clear previous timeout
    if (activityTimeoutRef.current) {
      clearTimeout(activityTimeoutRef.current);
    }

    // Set timeout for inactivity
    activityTimeoutRef.current = setTimeout(() => {
      // ✅ Trigger popup only first time
      setCkeckTimer(true);
      popupShownRef.current = true;
    }, 15000);
  };

  //   useEffect(() => {
  //     // Function to reset activity timeout
  //     const handleActivity = () => {
  //       resetActivityTimeout();
  //     };

  //     // Add event listeners
  //     const events = ["mousedown", "keydown"];
  //     events.forEach((event) => window.addEventListener(event, handleActivity));
  //     console.log("rutu");
  //     // Initial timeout
  //     resetActivityTimeout();

  //     // Cleanup event listeners and timeout on component unmount
  //     return () => {
  //       events.forEach((event) =>
  //         window.removeEventListener(event, handleActivity),
  //       );
  //       if (activityTimeoutRef.current) {
  //         clearTimeout(activityTimeoutRef.current);
  //       }
  //     };
  //   }, []);
  useEffect(() => {
    const handleActivity = () => {
      resetActivityTimeout();
    };

    const events = ["mousedown", "keydown"];

    events.forEach((event) => window.addEventListener(event, handleActivity));

    resetActivityTimeout();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );

      if (activityTimeoutRef.current) {
        clearTimeout(activityTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!formik.values.annualIncome) {
      setAlertField("annualIncome");
    } else if (!formik.values.setDate) {
      setAlertField("setDate");
    } else if (!formik.values.firstName) {
      setAlertField("firstName");
    } else if (!formik.values.lastName) {
      setAlertField("lastName");
    } else if (!formik.values.gender) {
      setAlertField("gender");
    } else if (!formik.values.isSmoke) {
      setAlertField("isSmoke");
    } else if (!formik.values.mobileNumber) {
      setAlertField("mobileNumber");
    } else if (!formik.values.email) {
      setAlertField("email");
    } else if (!formik.values.isEmployee) {
      setAlertField("isEmployee");
    } else if (!formik.values.isState) {
      setAlertField("isState");
    } else {
      setAlertField(null);
    }
  }, [formik.values]);

  // useEffect(() => {
  //     console.log(focusedField === 'firstName' || !formik.values.firstName, focusedField, formik.values.firstName, 'dada')

  //     if (focusedField === 'firstName' || !formik.values.firstName) {
  //         setAlertField('firstName');
  //     } else if (focusedField === 'lastName' || !formik.values.lastName) {
  //         setAlertField('lastName');
  //     } else if (focusedField === 'mobileNumber' || !formik.values.mobileNumber) {
  //         setAlertField('mobileNumber');
  //     } else if (focusedField === 'email' || !formik.values.email) {
  //         setAlertField('email');
  //     } else {
  //         setAlertField(null);
  //     }
  // }, [formik.values, focusedField]);

  const handleConfirm = () => {
    setCkeckTimer(false)
    // setShowPopup(false);

    dispatch(setCallWidget("true"));
    console.log("dada");
  };

  const handleCancel = () => {
    console.log("dada");
    setCkeckTimer(false);
    // setCkeckTimer(false)
    // setAlertField('');
  };

  const handleFocus = (field) => {
    setFocusedField(field);
  };
  const handlecontinueclick = () => {
    dispatch(setPageCondition("2"));
    console.log("ttttt");
  };
  console.log(
    alertField === "annualIncome" && ckeckTimer,
    alertField,
    ckeckTimer,
    "rutu",
  );

  return (
    <div className="lower-part">
      <form onSubmit={formik.handleSubmit}>
        <div className="row mb-4">
          <div className="col-lg-12 col-sm-12 col-12">
            <div className="d-flex w-100">
              <div className="content-icon mr-2 mr-lg-3">
                <i className="icon icon-md icon-premium-amount" />
              </div>
              <div className="content-detail">
                <h3 className="label lato-bold">
                  What does your annual income look like?
                </h3>
                <p className="label-info mb-3 text-gray font-12 lato-regular font-weight-regular">
                  Help us calculate the best plan for you
                </p>
                <div className="outline-capsules">
                  {alertField === "annualIncome" && ckeckTimer && (
                    <Popup
                      message="Do you need any help?"
                      handleConfirm={handleConfirm}
                      onCancel={handleCancel}
                    />
                  )}

                  <div className="radio-capsule">
                    <div className="radio radio-toolbar">
                      <input
                        id="annualIncome1"
                        type="radio"
                        name="annualIncome"
                        value="10"
                        onFocus={() => handleFocus("annualIncome")}
                        onChange={formik.handleChange}
                      />
                      <label htmlFor="annualIncome1">5 Lacs-10 Lacs</label>
                    </div>
                    <div className="radio radio-toolbar">
                      <input
                        id="annualIncome2"
                        type="radio"
                        name="annualIncome"
                        value="5"
                        onFocus={() => handleFocus("annualIncome")}
                        onChange={formik.handleChange}
                      />
                      <label htmlFor="annualIncome2">&gt;10 Lacs</label>
                    </div>
                  </div>
                </div>

                <span className="text-danger">
                  {formik.errors.annualIncome}
                </span>
              </div>
            </div>
          </div>
        </div>
        <p
          className="inputdetail-label label-amount-in-words d-inline-block mb-3"
          style={{ marginLeft: 45 }}
        >
          Supporting Documents for Indicated Annual Income will be mandatory at
          later stage
        </p>
        <div className="row mb-4">
          <div className="col-lg-12 col-sm-12 col-12 mt-4">
            {alertField === "setDate" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex w-100">
              <div className="content-icon mr-2 mr-lg-3">
                <i className="icon icon-md icon-invest-duration" />
              </div>
              <div className="content-detail">
                <div className="form-group mb-2">
                  <div className="form-box mb-2">
                    <label className="label  lato-bold" htmlFor="dob">
                      Date of Birth
                    </label>
                    <div className="position-relative datepicker-parent">
                      <DatePicker
                        id="setDate"
                        name="setDate"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control form-control-lg datepicker-ip"
                        placeholderText="Select Date"
                        selected={formik.values.setDate}
                        onChange={(date) =>
                          formik.setFieldValue("setDate", date)
                        }
                        onBlur={formik.handleBlur}
                      />
                      <span className="text-danger">{formik.errors.dob}</span>
                    </div>
                  </div>
                  <span className="inputdetail-label label-amount-in-words d-inline-block mb-3">
                    <span className="nominee-name">Your age is </span>
                    <span>
                      {formik.values.dob
                        ? new Date().getFullYear() -
                          new Date(formik.values.dob).getFullYear()
                        : ""}
                    </span>
                    &nbsp;years
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-6 col-sm-12 col-12 mb-24">
            {alertField === "firstName" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-md-main icon-first-name-v2" />
              </div>
              <div className="content-details">
                <h6 className="label lato-bold">Your First</h6>
                <div className="form-group">
                  <div className="input-box">
                    <input
                      name="firstName"
                      type="text"
                      id="firstName"
                      className="form-control"
                      placeholder="First Name"
                      value={formik.values.firstName}
                      onBlur={(e) => {
                        formik.handleBlur(e);
                      }}
                      onFocus={() => handleFocus("firstName")}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="text-danger">
                        {formik.errors.firstName}
                      </div>
                    ) : null}
                  </div>
                </div>
                <span className="inputdetail-label label-amount-in-words d-inline-block mb-3">
                  As per Government ID proof
                </span>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 col-12">
            {/* <DisabledPortalPopup/> */}
            {alertField === "lastName" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-md-main icon-first-name-v2" />
              </div>
              <div className="content-details">
                <h3 className="label lato-bold">Your Last Name</h3>
                <div className="form-group">
                  <div className="input-box">
                    <input
                      name="lastName"
                      type="text"
                      id="lastName"
                      className="form-control"
                      placeholder="Last Name"
                      value={formik.values.lastName}
                      onFocus={() => handleFocus("lastName")}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="text-danger">
                        {formik.errors.lastName}
                      </div>
                    ) : null}
                  </div>
                </div>
                <span className="inputdetail-label label-amount-in-words d-inline-block mb-3">
                  As per Government ID proof
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="gender-section" className="row mb-4">
          <div className="col-lg-6 col-sm-12 col-12 mb-24">
            {alertField === "gender" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-xs-main icon-gender-v2" />
              </div>

              <div className="content-details">
                <h3 className="label lato-bold">Your Gender</h3>
                <div className="radio-button-block mt-3 my-2">
                  <div className="radio-toolbar policy-details">
                    <div className="radio-two">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <input
                                id="male"
                                type="radio"
                                name="gender"
                                value="male"
                                onFocus={() => handleFocus("gender")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="male">Male</label>
                            </td>
                            <td>
                              <input
                                id="female"
                                type="radio"
                                name="gender"
                                value="female"
                                onFocus={() => handleFocus("gender")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="female">Female</label>
                            </td>
                            <td>
                              <input
                                id="transgender"
                                type="radio"
                                name="gender"
                                value="transgender"
                                onFocus={() => handleFocus("gender")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="transgender">Transgender</label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <span className="text-danger">{formik.errors.gender}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 col-12">
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-xs-main icon-smoke-v2" />
              </div>
              <div className="content-details">
                {alertField === "isSmoke" && ckeckTimer && (
                  <Popup
                    message="Do you need any help?"
                    handleConfirm={handleConfirm}
                    onCancel={handleCancel}
                  />
                )}
                <h3 className="label lato-bold">Do you Smoke?</h3>
                <div className="radio-button-block mt-3 my-2">
                  <div className="radio-toolbar policy-details">
                    <div className="radio-two">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <input
                                id="smoke-yes"
                                type="radio"
                                name="isSmoke"
                                value="yes"
                                onFocus={() => handleFocus("gender")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="smoke-yes">Yes</label>
                            </td>
                            <td>
                              <input
                                id="smoke-no"
                                type="radio"
                                name="isSmoke"
                                value="no"
                                onFocus={() => handleFocus("gender")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="smoke-no">No</label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <span className="text-danger">{formik.errors.smoke}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="contact-section" className="row mb-4">
          <div className="col-lg-6 col-sm-12 col-12 mb-24">
            {alertField === "mobileNumber" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-xs-main icon-mobile-v2" />
              </div>
              <div className="content-details">
                <h3 className="label lato-bold">Mobile No.</h3>
                <div className="form-group">
                  <div className="input-box">
                    <input
                      name="mobileNumber"
                      type="text"
                      id="mobileNo"
                      className="form-control"
                      placeholder="Enter 10 digit number"
                      value={formik.values.mobileNumber}
                      onChange={formik.handleChange} // value={formik.values.mobileNumber}
                    />
                    {formik.touched.mobileNumber &&
                    formik.errors.mobileNumber ? (
                      <div className="text-danger">
                        {formik.errors.mobileNumber}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 col-12">
            {alertField === "email" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-xs-main icon-email-v2" />
              </div>
              <div className="content-details">
                <h3 className="label lato-bold">Email ID</h3>
                <div className="form-group">
                  <div className="input-box">
                    <input
                      name="email"
                      type="text"
                      id="email"
                      className="form-control"
                      placeholder="Enter your email id"
                      onChange={formik.handleChange} // onFocus={() => handleFocus("email")}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-danger">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="sbg-group-section" className="row mb-4">
          <div className="col-lg-6 col-sm-12 col-12 mb-24">
            {alertField === "isEmployee" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-xs-main icon-sbg-v2" />
              </div>
              <div className="content-details">
                <h3 className="label lato-bold">
                  Are you a Bosa Bank Group Employee?
                </h3>
                <div className="radio-button-block mt-3 my-2">
                  <div className="radio-toolbar policy-details">
                    <div className="radio-two">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <input
                                id="sbg-yes"
                                type="radio"
                                name="isEmployee"
                                value="yes"
                                onFocus={() => handleFocus("isEmployee")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="sbg-yes">Yes</label>
                            </td>
                            <td>
                              <input
                                id="sbg-no"
                                type="radio"
                                name="isEmployee"
                                value="no"
                                onFocus={() => handleFocus("isEmployee")}
                                onChange={formik.handleChange}
                              />
                              <label htmlFor="sbg-no">No</label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <span className="text-danger">{formik.errors.sbgGroup}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 col-12">
            {alertField === "isState" && ckeckTimer && (
              <Popup
                message="Do you need any help?"
                handleConfirm={handleConfirm}
                onCancel={handleCancel}
              />
            )}
            <div className="d-flex">
              <div className="content-icons mr-2 mr-lg-3">
                <i className="icon icon-xs-main icon-state-v2" />
              </div>
              <div className="content-details">
                <h3 className="label lato-bold">
                  Which State do you belong to?
                </h3>
                <div className="form-group">
                  <div className="select-box">
                    <select
                      name="isState"
                      id="state"
                      className="selectform-control"
                      onChange={formik.handleChange} // onFocus={() => handleFocus("email")}
                      value={formik.values.isState}
                    >
                      <option value="">Select your state</option>
                      <option value="ANDAMAN">ANDAMAN AND NICOBAR</option>
                      <option value="ANDHRA">ANDHRA PRADESH</option>
                      <option value="ARUNACHAL">ARUNACHAL PRADESH</option>
                      <option value="ASSAM">ASSAM</option>
                      <option value="BIHAR">BIHAR</option>
                      <option value="CHANDIGARH">CHANDIGARH</option>
                      <option value="CHATTISGARH">CHATTISGARH</option>
                      <option value="DADRA">DADRA AND NAGAR HAVELI</option>
                      <option value="DAMAN">DAMAN AND DIU</option>
                      <option value="DELHI">DELHI</option>
                    </select>
                    <span className="text-danger">{formik.errors.state}</span>
                  </div>
                </div>
              </div>
            </div>
            {focusedField === "state" && (
              <div className="popup">
                <p>Hi there! Need help selecting your annual income range?</p>
                <button className="popup-button">Yes</button>
                <button
                  onClick={() => setFocusedField(null)}
                  className="popup-button"
                >
                  No
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="ml-55">
          <div className="form-group">
            <span className="align-items-start">
              <input
                id="ctl00_ctl00_MainContent_BenefitsMst_chkprivacypolicy"
                type="checkbox"
                name="ctl00$ctl00$MainContent$BenefitsMst$chkprivacypolicy"
                required
              />
            </span>
            <span
              style={{ marginLeft: "5px" }}
              className="h6 lato-regular font-weight-medium lh-20 text-left text-Kettle-black"
            >
              I accept Bosa Life
              <span style={{ marginLeft: "5px" }}>
                <a href="" target="_blank" rel="noopener noreferrer">
                  Privacy policy
                </a>
              </span>
              <span style={{ marginLeft: "5px" }}>
                and by submitting my contact details here, I override my NCPR
                registration and authorise BOSA Life and its authorised
                representatives to contact me and send information/communication
                relating to this proposal/or the resulting policy through SMS
                /Email /Phone /Letter /WhatsApp /any other electronic mode of
                communication to my registered email id/mobile number.
              </span>
            </span>
            <p />
          </div>
        </div>
      </form>
      <div className="text-center" style={{ marginTop: "30px" }}>
        <div>
          <div className="mb-3 position-relative d-inline-block">
            <button
              id="btnCalculatePremium"
              className="primary-btn primary-btn-right-icon"
              href=""
              //   disabled={!(formik.isValid && formik.dirty)}
              onClick={handlecontinueclick}
            >
              Continue
              <div className="btn-arrow">
                <i className="icon icon-xs-v1 icon-btn-arrow"></i>
              </div>
            </button>
          </div>
        </div>
        <a href="" className="link font-12 lato-regular lh-15 px-2">
          <a id="lnkDisclaimer" className="link-underline" href="">
            Disclaimer
          </a>
        </a>
      </div>
    </div>
  );
}

export default TestBoss;
